// extracted by mini-css-extract-plugin
export default {"blockwrapper":"SN","header":"TN","name":"UN","columns":"VN","imagewrapper":"WN","addinfo":"XN","description":"YN","price":"ZN","old":"aO","new":"bO","desc_d":"cO","infoblock":"eO","desc_m":"fO"};
    if(module.hot) {
      // 1715276859115
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  